import { PropsWithChildren } from 'react';

export const RequestHeaderText = ({ children }: PropsWithChildren) => {
  return <h3 className="px-2 py-1 bg-secondary text-white text-sm rounded-md">{children}</h3>;
};
